import { render } from "./DragAndDrop.vue?vue&type=template&id=279177b2&scoped=true"
import script from "./DragAndDrop.vue?vue&type=script&lang=js"
export * from "./DragAndDrop.vue?vue&type=script&lang=js"

import "./DragAndDrop.vue?vue&type=style&index=0&id=279177b2&scoped=true&lang=css"

import exportComponent from "/var/www/extranet-sinistre-agemi/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279177b2"]])

export default __exports__